// extracted by mini-css-extract-plugin
export var bbcyan = "PagePanel-module--bbcyan--b7740";
export var bbred = "PagePanel-module--bbred--1afc4";
export var buttonPanel = "PagePanel-module--buttonPanel--60fb0";
export var cta = "PagePanel-module--cta--57e33";
export var ctaIcon = "PagePanel-module--ctaIcon--257df";
export var description = "PagePanel-module--description--292b6";
export var orange = "PagePanel-module--orange--74427";
export var purple = "PagePanel-module--purple--5740a";
export var root = "PagePanel-module--root--e2a7f";